import { useEffect, useState } from "react";
import { EditAccessAccordion } from "./EditAccessAccordion";

export function EditAccess() {

    const [loading, setLoading] = useState(false);
    const [accordionStates, setAccordionStates] = useState({ manager: false, user: false });
    const [adminRules, setAdminRules] = useState([{
        reports: { create: false, read: false, update: false }
    }]);
    const [scribeRules, setScribeRules] = useState([{
        reports: { create: false, read: false, update: false }
    }]);
    const [proofRules, setProofRules] = useState([{
        reports: { create: false, read: false, update: false }
    }]);

    return (
        <div className="accordion-content">
            <EditAccessAccordion accordionStates={accordionStates} setAccordionStates={setAccordionStates}
                rules={scribeRules} setRules={setScribeRules} loading={loading} state={"manager"} label={"Manager"}
                onUpdate={() => { }} />
            <EditAccessAccordion accordionStates={accordionStates} setAccordionStates={setAccordionStates}
                rules={proofRules} setRules={setProofRules} loading={loading} state={"user"} label={"User"}
                onUpdate={() => { }} />
        </div>
    );
}


